<template>
  <div v-if="showSupportOptions">
    <div id="support">
      <el-row id="support-container">
        <div id="powered-container">
          <span
            @click="safetyPage()">
            <img
              src="@/assets/powered-safety.svg"
              class="powered-img">
          </span>
        </div>
        <div id="support-container">
          <el-button
            type="primary"
            class="support-btn"
            @click="supportVideoVisible = true">
            <i class="el-icon-caret-right" /> {{$t('Video Tutorial')}}
          </el-button>
          <el-button
            type="info"
            class="support-btn bg-amsa-light-blue"
            @click="supportFormVisible = true">
            <i class="el-icon-message" /> {{$t('Escríbenos')}}
          </el-button>
          <el-button
            type="info"
            class="support-btn bg-amsa-red"
            @click="supportPhoneVisible = true">
            <i class="el-icon-phone-outline" /> {{$t('Llámanos')}}
          </el-button>
        </div>
      </el-row>


      <!--Dialog teléfono-->
      <el-dialog
        :visible.sync="supportPhoneVisible"
        :title="$t('¿Necesitas Ayuda?')"
        width="30%"
        center>
          <hr>
          <!--p class="support-phone-1">+56 2 2666 5844</p-->
          <!--p class="support-phone-2">+56 9 7499 5325</p-->
          <p class="support-phone-1">+56 9 7499 5325</p>
          <hr>
          <p class="support-text">
            {{$t('También puede comunicarse con nosotros escribiendo directamente a <b>support@safetyclub.zendesk.com</b>')}}
          </p>
          <p class="support-text">
            <i>{{$t('Horario atención telefónica: Lunes a Viernes de 9:00 a 19:00')}}</i>
          </p>
          <span
            slot="footer"
            class="dialog-footer">
            <el-button @click="supportPhoneVisible = false">{{$t('Cerrar')}}</el-button>
          </span>
      </el-dialog>


      <!--Dialog correo-->
      <el-dialog
        title="¿Necesitas Ayuda?"
        :visible.sync="supportFormVisible"
        width="30%"
        center>
          <el-form :model="form" status-icon :rules="rules" ref="form">
            <el-form-item :label="$t('Nombre Completo*')" prop="nombre">
              <el-input v-model="form.nombre"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Correo*')" prop="correo">
              <el-input v-model="form.correo"></el-input>
            </el-form-item>
            <el-form-item type="number" :label="$t('Teléfono')" prop="telefono">
              <el-input v-model="form.telefono">
                <template slot="prepend">+56</template>
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('Tipo de Usuario')">
              <br>
              <el-select
                v-model="form.role"
                class="w-100"
                prop=""
                :placeholder="$t('Seleccione tipo de usuario')">
                  <el-option
                    v-for="(value, key) in bhpProfiles"
                    :key="key"
                    :label="value"
                    :value="key">
                  </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('Mensaje*')" prop="mensaje">
              <el-input type="textarea" v-model="form.mensaje"></el-input>
            </el-form-item>
          </el-form>
          <p class="support-text">
            {{$t('También puede comunicarse con nosotros escribiendo directamente a <b>support@safetyclub.zendesk.com</b> o llamando al <b>+56 2 2666 5844</b>.')}}
          </p>
          <p class="support-text">
            <i>{{$t('Horario atención telefónica y chat: Lunes a Vienes de 9:00 a 19:00')}}</i>
          </p>
          <span slot="footer" class="dialog-footer">
            <el-button @click="cleanForm">{{$t('Cancelar')}}</el-button>
            <el-button type="primary" @click="sendMail('form')">{{$t('Enviar')}}</el-button>
          </span>
      </el-dialog>


      <el-dialog
        title="Tutorial Inventario de Riesgos"
        :visible.sync="supportVideoVisible">
          <!-- Video Administrador Plataforma -->
          <div v-if="admin">
            <p class="text-tutorial">
              'El siguiente video corresponde a un tutorial para <b><span class="text-amsa">Administradores de Plataforma</span></b>
            <p>
            <div class="video-cont">
              <div class="resp-container">
                <iframe
                  class="resp-iframe"
                  src="https://www.youtube.com/embed/_Co8qTMdNhw"
                  frameborder="0"
                  allow="autoplay; encrypted-media"
                  allowfullscreen/>
              </div>
            </div>

            <h3 class="title-download">
              {{ $t('Descargar Tutorial') }}
            </h3>

            <div class="download-box">
              <a target="_blank" href="https://storage.googleapis.com/bhp-inventarios/tutoriales/C%C3%B3mo%20administrar%20Inventario%20de%20Riesgos%20480.mp4">
                <div class="icon">
                  <i class="fa fa-minus" aria-hidden="true"></i>
                </div>
                <div class="text">
                  {{$t('Baja calidad')}}
                  <br>
                  <span class="mini-text">({{$t('menos peso')}})</span>
                </div>
              </a>
              <a target="_blank"
                href="https://storage.googleapis.com/bhp-inventarios/tutoriales/C%C3%B3mo%20administrar%20Inventario%20de%20Riesgos%20HD%201080.mp4">
                  <div class="icon">
                    <i class="fa fa-bars" aria-hidden="true"></i>
                  </div>
                  <div class="text">
                    {{$t('Alta calidad')}}
                    <br>
                    <span class="mini-text">({{$t('más peso')}})</span>
                  </div>
              </a>
            </div>
          </div>
          <br>
          <!-- Video Revisor -->
          <div v-if="reviewer">
            <p class="text-tutorial">
              El siguiente video corresponde a un tutorial para <b><span class="text-amsa">Revisores</span></b>, que son aquellos que su función es analizar y revisar los riesgos de los inventarios
            <p>
            <div class="video-cont">
              <div class="resp-container">
                <iframe
                  class="resp-iframe"
                  src="https://www.youtube.com/embed/C7VqvNwMFQc"
                  frameborder="0"
                  allow="autoplay; encrypted-media"
                  allowfullscreen/>
              </div>
            </div>

            <h3 class="title-download">
              {{ $t('Descargar Tutorial') }}
            </h3>

            <div class="download-box">
              <a target="_blank"
                href="https://storage.googleapis.com/bhp-inventarios/tutoriales/C%C3%B3mo%20revisar%20un%20Inventario%20de%20Riesgos%20480.mp4">
                  <div class="icon">
                    <i class="fa fa-minus" aria-hidden="true"></i>
                  </div>
                  <div class="text">
                    {{$t('Baja calidad')}}
                    <br>
                    <span class="mini-text">({{$t('menos peso')}})</span>
                  </div>
              </a>
              <a target="_blank"
                href="https://storage.googleapis.com/bhp-inventarios/tutoriales/C%C3%B3mo%20revisar%20un%20Inventario%20de%20Riesgos%20HD%201080.mp4">
                  <div class="icon">
                    <i class="fa fa-bars" aria-hidden="true"></i>
                  </div>
                  <div class="text">
                    {{$t('Alta calidad')}}
                    <br>
                    <span class="mini-text">({{$t('más peso')}})</span>
                  </div>
              </a>
            </div>
          </div>
          <!-- Video Creador o Default -->
          <div v-if="creator || !creator && !reviewer && !admin">
            <p class="text-tutorial">{{$t('El siguiente video corresponde a un tutorial para <b>Coordinadores</b>, que son aquellos que su función es crear los inventarios')}}:<p>
            <div class="video-cont">
              <div class="resp-container">
                <iframe
                  class="resp-iframe"
                  src="https://www.youtube.com/embed/S3-vq2MX4QA"
                  frameborder="0"
                  allow="autoplay; encrypted-media"
                  allowfullscreen/>
              </div>
            </div>
            <h3 class="title-download">
              {{$t('Descargar Tutorial')}}
            </h3>
            <div class="download-box">
              <a target="_blank"
                href="https://storage.googleapis.com/bhp-inventarios/tutoriales/C%C3%B3mo%20crear%20un%20Inventario%20de%20Riesgos%20480.mp4">
                  <div class="icon">
                    <i class="fa fa-minus" aria-hidden="true"></i>
                  </div>
                  <div class="text">
                    {{$t('Baja calidad')}}
                    <br>
                    <span class="mini-text">({{$t('menos peso')}})</span>
                  </div>
              </a>
              <a target="_blank"
                href="https://storage.googleapis.com/bhp-inventarios/tutoriales/C%C3%B3mo%20crear%20un%20Inventario%20de%20Riesgos%20HD%201080.mp4">
                  <div class="icon">
                    <i class="fa fa-bars" aria-hidden="true"></i>
                  </div>
                  <div class="text">
                    {{ $t('Alta calidad') }}
                    <br>
                    <span class="mini-text">
                      ({{ $t('más peso') }})
                    </span>
                  </div>
              </a>
            </div>
          </div>

          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="supportVideoVisible = false">{{ $t('Cerrar') }}</el-button>
          </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

const SERVICE_EMAIL_URL = '/usuarios/mailing/soporte';

export default {
  name: 'supportFooter',
  computed: {
    ...mapGetters({
      isLoggedIn: 'isLoggedIn',
      user: 'user',
      role: 'role',
    }),
  },
  data() {
    const validarNombre = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error(this.$t('Nombre es obligatorio')));
      }
      callback();
    };
    const validarCorreo = (rule, value, callback) => {
      const re = new RegExp('^[_a-z0-9-]+(.[_a-z0-9-]+)*@[a-z0-9-]+(.[a-z0-9-]+)*(.[a-z]{2,4})$');
      if (value === '') {
        return callback(new Error(this.$t('Correo es obligatorio')));
      } if (!value.match(re)) {
        return callback(new Error(this.$t('Error formato correo')));
      }
      callback();
    };
    const validarTelefono = (rule, value, callback) => {
      const pattern = new RegExp('^\\d{9}$');
      if (value === '' || !value.match(pattern)) {
        return callback(new Error(this.$t('Error formato teléfono: 9 números')));
      }
      callback();
    };
    const validarMensaje = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error(this.$t('Mensaje es obligatorio')));
      }
      callback();
    };
    return {
      showSupportOptions: false,
      supportVideoVisible: false,
      supportFormVisible: false,
      supportPhoneVisible: false,
      sendingEmail: false,
      creator: false,
      reviewer: false,
      admin: false,
      bhpProfiles: {
        hse: 'Asesor SSO',
        health: this.$t('Especialista de Salud'),
        safety: this.$t('Especialista de Seguridad'),
        environment: this.$t('Especialista de Medioambiente'),
        contractor_hse: this.$t('Asesor SSO Contratista'),
        owner: this.$t('Dueño de Contrato'),
        contract_owner: this.$t('Dueño de Contrato'),
        risk: this.$t('Especialista de Riesgo'),
        administrator: this.$t('Administrador de Contrato'),
        contractor_coordinator: this.$t('Coordinador Contratista'),
        coordinator: this.$t('Coordinador'),
        manager: this.$t('Gerente de Área'),
        super: this.$t('Superintendente de Área'),
        general_manager: this.$t('Gerente General'),
      },
      form: {
        nombre: '',
        correo: '',
        telefono: '',
        perfil: '',
        mensaje: '',
      },
      rules: {
        nombre: [
          { validator: validarNombre, trigger: 'blur' },
        ],
        correo: [
          { validator: validarCorreo, trigger: 'blur' },
        ],
        telefono: [
          { validator: validarTelefono, trigger: 'blur' },
        ],
        mensaje: [
          { validator: validarMensaje, trigger: 'blur' },
        ],
      },
    };
  },
  created() {
    if (this.role) {
      if (this.role.admin) { this.admin = true; }
      if (['coordinator', 'contractor_coordinator'].includes(this.role.role)) {
        this.creator = true;
      } else {
        this.reviewer = true;
      }
    }

    // CHAT
    this.setShowSupportOptions();
    // ZendeskChat
    window.zESettings = {
      webWidget: {
        offset: {
          horizontal: '0px',
          vertical: '0px',
        },
        chat: {
          suppress: false,
        },
        talk: {
          suppress: false,
        },
        helpCenter: {
          suppress: false,
        },
        contactForm: {
          suppress: true,
        },
      },
    };
  },
  watch: {
    isLoggedIn() {
      this.setShowSupportOptions();
    },
    showSupportOptions() {
      if (window.zE) {
        this.showSupportOptions ? window.zE.show() : window.zE.hide();
      } else if (this.showSupportOptions) {
        // Start of safetyclub Zendesk Widget script
        window.zE || (function (e, t, s) {
          var n = window.zE = window.zEmbed = function () {
            n._.push(arguments);
          };
          const a = n.s = e.createElement(t);
          const r = e.getElementsByTagName(t)[0];
          n.set = function (e) {
            n.set._.push(e);
          };
          n._ = [];
          n.set._ = [];
          a.async = true;
          a.setAttribute('charset', 'utf-8');
          a.src = `https://static.zdassets.com/ekr/asset_composer.js?key=${s}`;
          n.t = +new Date();
          a.type = 'text/javascript';
          r.parentNode.insertBefore(a, r);
        }(document, 'script', 'cd9487bd-3ef3-4a2c-8bcc-1d563414092d'));
      }
    },
  },
  methods: {
    setShowSupportOptions() {
      this.showSupportOptions = this.isLoggedIn;
    },
    sendMail(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log('enviando correo');
          this.sendingEmail = true;

          const config = {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          };
          axios.post(SERVICE_EMAIL_URL, { form: this.form }, config)
            .then((response) => {
              this.sendingEmail = false;
              this.$alert(this.$t('Correo enviado exitosamente.'), this.$t('Proceso exitoso'), {
                type: 'success',
              });
              this.cleanForm();
            })
            .catch((error) => {
              this.sendingEmail = false;
              console.error(error);
              this.$alert(this.$t('Lo sentimos, ha surgido un error. Intente nuevamente.'), this.$t('Atención'), {
                type: 'error',
              });
            });
        } else {
          console.log('formulario no válido');
          return false;
        }
      });
    },
    cleanForm() {
      this.form.nombre = '';
      this.form.correo = '';
      this.form.telefono = '';
      this.form.role = '';
      this.form.mensaje = '';

      this.supportFormVisible = false;
    },
  },
};
</script>

<style scoped>
#support {
  margin-top: 80px;
}
#Embed {
  display: none;
}
#support-container {
  position: fixed;
  bottom: 10px;
  right: 150px;
  z-index: 999;
}
#powered-container {
  position: fixed;
  bottom: 10px;
  left: 150px;
  z-index: 999;
}
[class*=" el-icon-"], [class^=el-icon-] {
  font-weight: bold;
}
.el-button {
  letter-spacing: .6;
  font-size: .90rem;
  font-weight: 600;
  padding: 15px;
}
.support-btn {
  height: 47px;
  border: none;
  border-radius: 999rem;
}
.support-text {
  text-align: center;
}
.support-phone-1 {
  text-align: center;
  font-size: 3em;
}
.support-phone-2 {
  text-align: center;
  font-size: 2em;
}
.powered-img {
  height: 16px;
}
.text-tutorial {
  font-size: 18px;
}
</style>
